export default __webpack_public_path__ + "static/media/radio_gong.81346498.png";